import { render } from "./HospitalsReport.vue?vue&type=template&id=54f3173d"
import script from "./HospitalsReport.vue?vue&type=script&lang=js"
export * from "./HospitalsReport.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/reports/HospitalsReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54f3173d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54f3173d', __exports__)) {
    console.log('reload')
    api.reload('54f3173d', __exports__)
  }
  
  module.hot.accept("./HospitalsReport.vue?vue&type=template&id=54f3173d", () => {
    console.log('re-render')
    api.rerender('54f3173d', render)
  })

}


export default __exports__